import { z } from 'zod';

/**
 * Validation schema for product variants
 * Must match the server-side VariantFieldsSchema expectations
 */
export const variantSchema = z.object({
    name: z.string().min(1, 'Variant name is required'),
    description: z.string().optional(),
    sku: z.string().nullable(),
    imageUrl: z.string().nullish(),
    grams: z.number().nullable(),
    active: z.boolean(),
    default: z.boolean(),
    price: z.number().nullable(),
    compareAtPrice: z.number().nullable(),
    prices: z.array(z.any()),
});

/**
 * Validation schema for product creation
 * Must match the server-side ProductFormSchema expectations
 */
export const createProductSchema = z.object({
    name: z.string().min(1, 'Product name is required'),
    description: z.string().nullish(),
    unitLabel: z.string().nullish(),
    accountingCode: z.string().nullish(),
    taxCategory: z.string().nullish(),
    mappedTaxCategoryId: z.string().nullish(),
    active: z.boolean(),
    isShippable: z.boolean(),
    isTaxable: z.boolean(),
    autoSync: z.boolean(),
    variants: z.array(variantSchema).min(1, 'At least one variant is required'),
});

export type CreateProductFormData = z.infer<typeof createProductSchema>;
export type VariantFormData = z.infer<typeof variantSchema>;

